import { invert } from "lodash";

export const AfricanCountries = {
	DZ: "Algerie",
	EG: "Egypte",
	LY: "Libye",
	MA: "Maroc",
	MR: "Mauritanie",
	TN: "Tunisie",
	BJ: "Benin",
	BF: "Burkina Faso",
	CV: "Cap-Vert]",
	CI: "Côte d’Ivoire",
	GM: "Gambie",
	GH: "Ghana",
	GN: "Guinee",
	GW: "Guinee-Bissau",
	LR: "Liberia",
	ML: "Mali",
	NE: "Niger",
	NG: "Nigeria",
	SN: "Senegal",
	SL: "Sierra Leone",
	TG: "Togo",
	CM: "Cameroun",
	GA: "Gabon",
	GQ: "Guinee equatoriale",
	CF: "Republique centrafricaine",
	CD: "Republique democratique du Congo",
	CG: "Republique du Congo",
	TD: "TD",
	BI: "Burundi",
	DJ: "Djibouti",
	ER: "Erythree",
	ET: "Ethiopie",
	KE: "Kenya",
	UG: "Ouganda",
	RW: "Rwanda",
	SC: "Seychelles",
	SO: "Somalie",
	SD: "Soudan du Sud",
	TZ: "Tanzanie",
	ZA: "Afrique du Sud",
	AO: "Angola",
	BW: "Botswana",
	KM: "Comores",
	LS: "Lesotho",
	MG: "Madagascar",
	MW: "Malawi",
	MU: "Maurice",
	MZ: "Mozambique",
	NA: "Namibie",
	ZM: "Zambie",
	ZW: "Zimbabwe",
} as const;

export type AfricanCountryCode = keyof typeof AfricanCountries;
export type AfricanCountry = (typeof AfricanCountries)[AfricanCountryCode];
export const allAfricanCountrycodes = Object.keys(AfricanCountries) as AfricanCountryCode[];
export const allAfricanCountry = Object.values(AfricanCountries).sort() as AfricanCountry[];

export const AfricancountryCodes = invert(AfricanCountries) as { [key in AfricanCountry]: AfricanCountryCode };
